// extracted by mini-css-extract-plugin
export default {"decoration":"Input_decoration__gGcNc"};